
import categoryMixin from '@/mixins/categoryMixin'

const CUTOUTS = {}

export default {
  name: 'CategoryHubTile',
  mixins: [categoryMixin],
  props: {
    category: {
      type: Object,
      required: true,
    },
    look: {
      type: String,
      default: 'tile',
    },
    lit: {
      type: Boolean,
      default: false,
    },
    eager: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cutout() {
      const size = this.look === 'tile' && CUTOUTS[this.category.id]
      if (!size) return null
      return {
        src: `/category-cutouts/${this.category.id}.webp`,
        width: size[0],
        height: size[1],
      }
    },
    image() {
      return this.category.cover_image || this.category.images?.[0] || null
    },
    size() {
      return this.look === 'row' ? 96 : 360
    },
    isAdmin() {
      return (
        this.$auth.loggedIn && this.$auth.user?.role?.identifier === 'admin'
      )
    },
  },
}
